<script>
	import router from "page"
	import routes from "./routes.js"

	import { onMount } from "svelte"

	import AuthenticationService from "./services/authentication"
	import Easter from './components/Easter.svelte'

	let page
	let pageSelected = "/home"
	let params

	let easterComponent

	onMount(() => {
		const urlParams = new URLSearchParams(window.location.search)

		pageSelected = window.location.pathname

		routes.forEach((route) => {
			router(
				route.path,

				(ctx, next) => {
					params = ctx.params;
					next();
				},

				() => {
					if (route.auth && !AuthenticationService.isAuthenticated()) {
						router.redirect(`/login?redirect=${route.path}`)
					} else {
						if (route.role && !AuthenticationService.hasAuthorization(route.role)) {
							router.redirect(`/`)
						} else {
							page = route.component
							pageSelected = route.path
							console.log(pageSelected)
						}
					}

				}
			)
		})

		router.start()

	})

	const openEaster = () => {
        easterComponent.start()
    }

</script>

<svelte:head>
	<link href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-icons/1.8.1/font/bootstrap-icons.min.css" rel="stylesheet">
</svelte:head>

<svelte:body/>

<div style="position: fixed;top: 0px;left: 0px;bottom: 0px;right: 0px;background-color: rgba(0, 0, 0, 0.4);z-index: -1;">
	<Easter bind:this="{easterComponent}"></Easter>
</div>

<svelte:component this={page} {params} />

<div class="container">		
	<div class="row mt-4">
		<div class="col-12 text-center text-white">
			<p class="pointer" on:click={openEaster}>Fait avec ♥️ pour la famille</p>
		</div>
	</div>
</div>


<style>

	:global(html, body) {
		height: calc(100%);
	}

	:global(body) {
		background-image: url('https://source.unsplash.com/random/1920x1080');
		background-attachment: fixed;
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	.pointer {
		cursor: pointer;
	}

</style>
